<template>
    <div>
        <svg width="340" height="200" v-if="scoreData && scoreData.length > 1">
            {{scoreData}}
        </svg>
        <div v-else style="padding: 15px;">
            <i>Sorry, there is insufficienct data for plotting.</i>
        </div>
    </div>
</template>

<script>
    var d3 = Object.assign({},  
        require("d3-selection"), 
        require("d3-axis"),  
        require("d3-scale"),  
        require("d3-shape"),  
        require("d3-array"),  
    ); 

    function kernelDensityEstimator(kernel, X) {
        return function (V) {
            return X.map(function (x) {
                return [x, d3.mean(V, function (v) {
                    return kernel(x - v);
                })];
            });
        };
    }

    function kernelEpanechnikov(k) {
        return function (v) {
            return Math.abs(v /= k) <= 1 ? 0.75 * (1 - v * v) / k : 0;
        };
    }

    export default {
        props: {
            xmin: {
                type: Number
            },
            xmax: {
                type: Number
            },
            graphWidth: {
                type: Number
            },
            graphHeight: {
                type: Number
            },
            scoreData: {
                type: Array, 
            },
            scoreIndicator: {
                type: Number
            }, 
            nbins: {
                type: Number
            },
            xlab: {
                type: String,
                default: "Score",
            },
            fillColor: {
                type: String,
                default: "#4682b4"
            }
        },
        methods: {
            drawHistogram: function (scoreData, scoreIndicator, nbins) {
                /* eslint-disable no-unused-vars */

                if(!(scoreData && scoreData.length > 1)) return
                
                var svg = d3.select(this.$el).select("svg")
                svg.selectAll("*").remove();
                if(svg == undefined) return
                var margin = {
                        top: 20,
                        right: 30,
                        bottom: 40,
                        left: 45
                    };
                var width = this.graphWidth
                var height = this.graphHeight
                if(width == undefined) width = svg.attr("width")
                if(height == undefined) height = svg.attr("height")
                var xmax = this.xmax
                var xmin = this.xmin
                if(xmin == undefined) xmin = d3.min(scoreData)-5
                if(xmax == undefined) xmax = d3.max(scoreData)+5
                var x = d3.scaleLinear()
                    .domain([xmin, xmax])
                    .range([margin.left, width - margin.right]);

                if(!nbins) nbins = 40
                var n = scoreData.length,
                    bins = d3.histogram().domain(x.domain()).thresholds(nbins)(scoreData),
                    density = kernelDensityEstimator(kernelEpanechnikov(7), x.ticks(nbins))(scoreData);
                var densityValues = density.map((x) => x[1])
                var y = d3.scaleLinear()
                    .domain([0, d3.max(densityValues)])
                    .range([height - margin.bottom, margin.top]);

                svg.append("g")
                    .attr("class", "axis axis--y")
                    .attr("transform", "translate(" + margin.left + ",0)")
                    .call(d3.axisLeft(y).ticks(null, "%"));

                /*svg.insert("g", "*")
                    .attr("fill", "#bbb")
                    .selectAll("rect")
                    .data(bins)
                    .enter().append("rect")
                    .attr("x", function (d) {
                        return x(d.x0) + 1;
                    })
                    .attr("y", function (d) {
                        return y(d.length / n);
                    })
                    .attr("width", function (d) {
                        return x(d.x1) - x(d.x0) - 1;
                    })
                    .attr("height", function (d) {
                        return y(0) - y(d.length / n);
                    });*/
                svg.append("path")
                    .datum(density)
                    .attr("fill", this.fillColor)
                    .attr("stroke", "#225177")
                    .attr("stroke-width", 1.5)
                    .attr("stroke-linejoin", "round")
                    .attr("d", d3.area()
                        .x(function (d) {
                            return x(d[0]);
                        })
                        .y0(height-margin.bottom)
                        .y1(function (d) {
                            return y(d[1]);
                        }));
                if(scoreIndicator != undefined && !isNaN(scoreIndicator)){
                    var verticalLine = svg.append('line')
                        .attr('transform', 'translate(' + x(scoreIndicator) + ', ' + margin.top + ')')
                        .attr("x1", 0)
                        .attr("y1", 0)
                        .attr("x2", 0)
                        .attr("y2", height-margin.bottom - margin.top)
                        .attr("stroke", "red")
                        .attr("stroke-width", 3)
                        .attr('class', 'verticalLine');
                    let xOffsetLabel = (scoreIndicator > 90) ? -30 : 8; 
                    var scoreIndicatorLabel = svg.append('text')
                        .attr('transform', 'translate(' + (x(scoreIndicator) + xOffsetLabel) + ', ' + (margin.top + 10)+ ')')
                        .attr("stroke", "red")
                        .text("You");
                }
                svg.append("g")
                    .attr("class", "axis axis--x")
                    .attr("transform", "translate(0," + (height - margin.bottom) + ")")
                    .call(d3.axisBottom(x))
                    .append("text")
                    .attr("x", width/2)
                    .attr("y", 34)
                    .attr("fill", "#000")
                    .attr("text-anchor", "end")
                    .attr("font-weight", "bold")
                    .text(this.xlab)
                    .style("text-anchor", "middle");
                /* eslint-enable no-unused-vars */
            }
        },
        watch: {
            scoreData: function(){
                this.drawHistogram(this.scoreData, this.scoreIndicator, this.nbins)
            },
            scoreIndicator: function(){
                this.drawHistogram(this.scoreData, this.scoreIndicator, this.nbins)
            },
            nbins: function(){
                this.drawHistogram(this.scoreData, this.scoreIndicator, this.nbins)
            }
        },
        mounted: function(){
            this.$nextTick(() => {
                this.drawHistogram(this.scoreData, this.scoreIndicator, this.nbins)
            })
        }
    }
</script>